import React, { useEffect } from 'react';
export const NavigationLink = ({ children, onRender, requiredAccountLevels, showLink }) => {
    useEffect(() => {
        onRender(showLink, requiredAccountLevels);
    }, [onRender, requiredAccountLevels, showLink]);
    return showLink ? React.createElement(React.Fragment, null, children) : null;
};
